/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import { Link, Switch, Redirect, Route } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Login from "./Login";
// import Registration from "./Registration";
//import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useDeviceDetect from "../../../../utilities/useDeviceDetect";
import classes from "../css/AuthPage.module.css";
import { useDispatch, useSelector } from "react-redux";
import { authSagaActions } from "..";


export function AuthPage() {

  const { deviceType } = useDeviceDetect();
  const currentYr = new Date().getFullYear();

  const dispatch = useDispatch();

  useEffect(()=>{

    dispatch(authSagaActions.loadLogos());

  },[dispatch]);

  const { auth } = useSelector((state) => state);

  const CourselItems = auth.logos.map((logo,idx) => <div key={idx} className={classes['c-item']}><img src={logo.base64String} alt={logo.name} /><p>{logo.name}</p></div>);


  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-2.jpg")})`,
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link to="/" className="flex-column-auto mt-5 pb-lg-0 pb-10">
                <img
                  alt="Logo"
                  src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
                />
              </Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">
                  E-Receipting Agency{" "}
                </h3>
                <p className="font-weight-lighter text-white opacity-80">
                  Use this application to administer the E-Receipting system for the Agency.{" "}
                </p>
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                {currentYr.toString()} &copy; Papua New Guinea Department of Finance
                </div>
                <div className="d-flex">
                  <a
                    href="https://www.finance.gov.pg/policy/privacy-policy"
                    className="text-white"
                  >
                    Privacy
                  </a>
                  
                  <a
                    href="https://www.finance.gov.pg/contact"
                    className="text-white ml-10"
                  >
                    Contact
                  </a>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            {/* <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <span className="font-weight-bold text-dark-50">
                Don't have an account yet?
              </span>
              <Link
                to="/auth/registration"
                className="font-weight-bold ml-2"
                id="kt_login_signup"
              >
                Sign Up!
              </Link>
            </div> */}
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <Route path="/auth/login" component={Login} />
                {/* <ContentRoute
                  path="/auth/registration"
                  component={Registration}
                /> */}
                {/* <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                /> */}
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/*begin::department listing*/}
            <div className="text-center mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
                <div className={classes['pa-title']}>
                  <span>Participating Agencies</span>
                  <hr/>
                </div>

                <Carousel
                  swipeable={false}
                  showDots={true}
                  draggable={false}
                  responsive={responsive}
                  ssr={true} // means to render carousel on server-side.
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={2000}
                  keyBoardControl={true}
                  customTransition="all .5"
                  transitionDuration={500}
                  removeArrowOnDeviceType	={['tablet','mobile']} 
                  containerClass={classes['carousel-container']}
                  deviceType={deviceType}
                  dotListClass={classes['carousel-dotList']}
                  itemClass={classes['carousel-item']}
                >
                  {CourselItems}
                </Carousel>
            </div>
            {/*end::department listing*/}


            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              &copy; 2021 Papua New Guinea Immigration &amp; Citizenship Authority
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <a
                  href="https://www.finance.gov.pg/policy/privacy-policy"
                  className="text-white"
                >
                  Privacy
                </a>
                <a
                  href="https://www.finance.gov.pg/contact"
                  className="text-white ml-10"
                >
                  Contact
                </a>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
